module.exports = __webpack_public_path__ + "img/12_l_uk.3de61ad3.svg";